import { Analytics } from './analytics'

export enum OrgAnalyticsEvent {
   betaOptedIn = 'Beta opted in',
   betaOptedOut = 'Beta opted out',
}

export default class OrgAnalytics implements Analytics {
   static betaOptedIn = () => {
      return Analytics.emitEvent(OrgAnalyticsEvent.betaOptedIn, { })
   }

   static betaOptedOut = () => {
      return Analytics.emitEvent(OrgAnalyticsEvent.betaOptedOut, { })
   }
}
